module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "futureLosses"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            Future Loss of Earnings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is there any future loss of earnings?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLosses),
      expression: "futureLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses",
      "disabled": _vm.retiredBetweenInjuryAndSettlement,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.retiredBetweenInjuryAndSettlement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                        Please note the Future Loss of Earnings is disabled as the claimant is set to retire\n                        before the assumed settlement therefore there is no Future Loss of Earnings\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLosses) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is the Future Loss Variable?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_constant",
      "tip-text": "In some cases the future losses may be variable and it may be necessary to split the future loss multipliers.",
      "tip-icon": "info",
      "tip-side": "right",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesConstant),
      expression: "futureLossesConstant"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_constant",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesConstant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clearFuturePeriods]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("No")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Claimant Level of Education\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "level_of_education"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.levelOfEducation),
      expression: "levelOfEducation"
    }],
    attrs: {
      "name": "level_of_education",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.levelOfEducation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Degree or equivalent or higher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GE-A"
    }
  }, [_vm._v("GCSE grades A–C up to A levels or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Below GCSE grade C or CSE grade 1 or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("No qualifications")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('level_of_education')
    }
  }, [_vm._v("\n                        Level of Education is required\n                    ")])], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Claimant Employed Prior to Injury?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_accident",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "right",
      "tip-text": "Those who at the time of the accident are employed, self-employed or on a government training scheme are classed as employed. All others (including those temporarily out of work, full-time students and unpaid family works) would be classed as not employed.",
      "tip-width": "250",
      "tip-name": "employed_at_accident"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAccident),
      expression: "employedAtAccident"
    }],
    attrs: {
      "id": "employed_at_accident"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Was the Claimant Disabled?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled",
      "modal-name": 'disabled-info',
      "icon-space": true,
      "tip-icon": "info",
      "tip-show": true,
      "tip-text": "Click to view information",
      "tip-side": "right",
      "tip-width": "140",
      "tip-name": "disabled-info"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAccident),
      expression: "disabledAtAccident"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                        Claimant Disabled is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.ageAtSettlement <= 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Pre-Injury Table A–D Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'table_a_d_discount_factor_' + _vm.uniqueId,
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": "preInjuryContingencyMultiplierPayload",
      "payload": _vm.preInjuryContingencyMultiplierPayload,
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preInjuryDiscountFactor),
      expression: "preInjuryDiscountFactor"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.preInjuryDiscountFactor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preInjuryDiscountFactor = $event.target.value
      }
    }
  })])], 1) : _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                        Please note the discount figures only apply up to age 54\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-40",
    attrs: {
      "slot": "b"
    },
    slot: "b"
  }, [_c('p', {
    staticClass: "c-warning-box--link"
  }, [_vm._v("Read the full description here")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.futureLossesConstant !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Will the Claimant Be Employed at Assessment?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_assessment",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "right",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "employed_at_assessment"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAssessment),
      expression: "employedAtAssessment"
    }],
    attrs: {
      "id": "employed_at_assessment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAssessment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Is the Claimant Disabled at Assessment?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled",
      "modal-name": 'disabled-info',
      "icon-space": true,
      "tip-icon": "info",
      "tip-show": true,
      "tip-text": "Click to view information",
      "tip-side": "right",
      "tip-width": "140",
      "tip-name": "disabled-info"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAssessment),
      expression: "disabledAtAssessment"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAssessment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                        Claimant Disabled is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.ageAtSettlement <= 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                    Assessment Table A–D Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": 'table_a_d_discount_factor_' + _vm.uniqueId,
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": "assessmentContingencyMultiplierPayload",
      "payload": _vm.assessmentContingencyMultiplierPayload,
      "table-control": true,
      "for": "claimant_disabled"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assessmentDiscountFactor),
      expression: "assessmentDiscountFactor"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.assessmentDiscountFactor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assessmentDiscountFactor = $event.target.value
      }
    }
  })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossOfEarningsValid &&
    (_vm.futureLossesConstant || !_vm.getIncomeValue('pastLossOfEarnings')) && _vm.futureLossesConstant !== null) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Multiplicand Earnings\n            ")]), _vm._v(" "), _c('post-accident-income')], 1) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossesConstant === false && _vm.futureLossOfEarningsValid) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Post Accident Earnings\n            ")]), _vm._v(" "), _c('strong', [_c('future-income', {
    attrs: {
      "name": "Claimant",
      "type": "future",
      "income": _vm.claimant.income,
      "retired": false
    },
    on: {
      "action": _vm.updateIncome
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Do losses continue into retirement?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_to_retirement",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesToRetirement),
      expression: "futureLossesToRetirement"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_to_retirement",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesToRetirement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Retirement Age\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "future_losses_retirement_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "50",
      "max": "80"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validRetirementAge
    }
  }, [_vm._v("\n                        Retirement age must be between 50 and 80.\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Retirement Date\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_end",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        End date of future losses\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_end",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesEnd),
      callback: function($$v) {
        _vm.futureLossesEnd = $$v
      },
      expression: "futureLossesEnd"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Age at End of future losses\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "future_losses_end_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossesEndAge),
      expression: "futureLossesEndAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.futureLossesEndAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossesEndAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.futureLosses && _vm.futureLossesConstant && _vm.futureLossOfEarningsValid) ? _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_losses_start",
      "label": "Start of Loss of Earnings"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    attrs: {
      "disabled": ""
    },
    on: {
      "input": _vm.updateFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesStart),
      callback: function($$v) {
        _vm.futureLossesStart = $$v
      },
      expression: "futureLossesStart"
    }
  })], 1), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('control', {
    attrs: {
      "for": "retirement_age",
      "label": "Retirement Age"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      }, _vm.updateTheFutureLossOfEarnings],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('control', {
    attrs: {
      "label": "Age at End of future losses",
      "for": "future_losses_end_age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossesEndAge),
      expression: "futureLossesEndAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "name": "retirement_age",
      "min": "18",
      "max": "100"
    },
    domProps: {
      "value": (_vm.futureLossesEndAge)
    },
    on: {
      "change": _vm.updateTheFutureLossOfEarnings,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossesEndAge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_losses_to_retirement",
      "label": "Do losses continue into retirement?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesToRetirement),
      expression: "futureLossesToRetirement"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_to_retirement",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesToRetirement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.futureLossesToRetirement) ? _c('control', {
    attrs: {
      "for": "future_losses_end",
      "label": "Retirement Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": function($event) {
        return _vm.updateTheFutureLossOfEarnings()
      }
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.validRangeOfLossOfEarnings()
    }
  }, [_vm._v("\n                            The end date of retirement should be after the start date.\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('control', {
    attrs: {
      "for": "future_losses_end",
      "label": "End date of future losses"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "required"
    }],
    on: {
      "input": _vm.updateTheFutureLossOfEarnings
    },
    model: {
      value: (_vm.futureLossesEnd),
      callback: function($$v) {
        _vm.futureLossesEnd = $$v
      },
      expression: "futureLossesEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.validRangeOfLossOfEarnings()
    }
  }, [_vm._v("\n                            The end date of future of losses should be after the start date.\n                        ")])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.futureLossesToRetirement === false) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Adjust Multiplier for Mortality?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses_mortality_multiplier",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossesMortalityMultiplier),
      expression: "futureLossesMortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses_mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossesMortalityMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateTheFutureLossOfEarningsAndIncome]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.results && _vm.futureLossesMortalityMultiplier !== null) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("\"But For\" earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.multiplier.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.preInjuryDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.preAccidentNetIncome)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(_vm.multiplier.toFixed(2)) + " x " + _vm._s(_vm.preInjuryDiscountFactor) + " x " + _vm._s(_vm.currencyFormat(_vm.preAccidentNetIncome)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.preResult)))])]), _vm._v(" "), _vm._l((_vm.getIncomeValue('futurePeriods')), function(period, index) {
    return (!_vm.futureLossesConstant) ? _c('tr', [(index === 0) ? _c('th', [_vm._v("Actual earnings")]) : _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.duration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.futureLossOfEarningsMultiplier || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(parseFloat(period.futureLossOfEarningsMultiplier || "0").toFixed(2)) + " x " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + " x " + _vm._s(_vm.currencyFormat(period.totalNetIncome)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodNetEarnings(period)))])]) : _c('tr', [_c('th', [_vm._v("Actual earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.multiplier).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.postAccidentMultiplicand)))]), _vm._v(" "), _c('td', [_vm._v("\n                            (" + _vm._s(parseFloat(_vm.multiplier).toFixed(2)) + " x " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + "\n                            x " + _vm._s(_vm.currencyFormat(_vm.postAccidentMultiplicand)) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.postResult)))])])
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                            Net Loss of Earnings\n                        ")]), _vm._v(" "), (!_vm.futureLossesConstant) ? _c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.preResult)) + " - " + _vm._s(_vm.currencyFormat(_vm.postNetTotal())) + "\n                        ")]) : _c('td', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.preResult)) + " - " + _vm._s(_vm.currencyFormat(_vm.postResult)) + "\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                            Total\n                        ")]), _vm._v(" "), (!_vm.futureLossesConstant) ? _c('td', [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(_vm.lossResult)) + "\n                            ")])]) : _c('td', [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(_vm.futureLossesConstantResult)) + "\n                            ")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "disabled-info",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Disabled")]), _vm._v("\n        A person is classified as being disabled if all three of the following conditions in relation to the\n        ill-health or disability are met:\n        "), _c('ol', {
    attrs: {
      "type": "i"
    }
  }, [_c('li', [_vm._v("the person has an illness or disability which has lasted or is expected to last for over a year or\n                is a progressive illness\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("the person satisfies the Equality Act 2010 definition that the impact of the disability\n                substantially limits the person's ability to carry out normal day to day activities, and\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("their condition affects either the kind "), _c('i', [_vm._v("or")]), _vm._v(" the amount of paid work they can do.")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'income_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "warning",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("The discount figures")]), _vm._v(" "), _c('p', [_vm._v("\n            Do you wish to discount the future loss of earnings multiplier for contingencies other than mortality?\n            For example, to reflect the risks and vicissitudes of life, such as periods not earning from ill-health\n            or loss of employment or taking care for dependents. If so then Tables A-D of the Ogden Tables provide\n            framework figures for discounting the multiplier to reflect these risks. Please note the discount\n            figures only apply up to age "), _c('strong', [_vm._v("54")]), _vm._v(". Thereafter the tables state:\n        ")]), _vm._v(" "), _c('blockquote', [_c('i', [_vm._v("‘For older ages the reduction factors increase towards 1 at retirement age for those\n            who are employed and fall towards 0 for those who are not employed. However, where the claimant is older\n            than "), _c('strong', [_vm._v("54")]), _vm._v(", it is anticipated that the likely future course if employment status will be\n            particularly dependent on individual circumstances, so that the use of factors based on averages would\n            not be appropriate. Hence reduction factors are not provided for older ages’.")])]), _vm._v(" "), _c('p', [_vm._v("ABC Quantum does however provide discount factors beyond age "), _c('strong', [_vm._v("54")]), _vm._v("\n            to retirement age by simple interpolation. So for an employed male aged "), _c('strong', [_vm._v("54")]), _vm._v(", not\n            disabled with A level qualifications the discount factor in "), _c('strong', [_vm._v("Table A is 0.79")]), _vm._v(". The figure\n            at retirement age of say "), _c('strong', [_vm._v("65/67 is 1.0")]), _vm._v(". For ages between "), _c('strong', [_vm._v("54–65/67")]), _vm._v("\n            we interpolate between the figures "), _c('strong', [_vm._v("0.79-1.0")]), _vm._v(".")])]), _vm._v(" "), _c('step-button', {
    staticClass: "u-margin-top-40",
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid a-form-inputs",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('h2', [_vm._v("\n                    Future Loss of Earnings\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Dates from")]), _vm._v(" "), _c('th', [_vm._v("Dates to")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), _c('th', [_vm._v("Net Annual Earnings")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Formula")]), _vm._v(" "), _c('th', [_vm._v("Total Net Earnings")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f61e22e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/FutureLosses.vue
// module id = 1625
// module chunks = 0